import React from "react";
import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { isNull, oneMonthBeforeToday, today } from "App/utils/helpers";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../PembelianWMS/helpers";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { isEmpty } from "lodash";

const urlHapusPembelian = "/wmsfarmasi/pembelian/delete-pembelian-terproses";
export const urlGet = LIST_URL_WAREHOUSE.pembelianPBF.get;
export const urlAllDaftarPembelianFarmasiExport =
  LIST_URL_WAREHOUSE.pembelianPBF.export;
export const urlDelete = LIST_URL_WAREHOUSE.pembelianPBF.delete;
export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  is_PO: "",
  status: "",
  supplier_id: "",
  gudang_id: "",
  no_faktur: "",
  gudang: "Pilih Gudang",
  supplier: "Pilih Supplier",
  kategory_tanggal: "tanggal pembelian",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  lunas: 0,
};

export const getByFilterPembelian = async (
  formFilter,
  pages,
  limit,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      halaman: pages,
      jumlah: limit,
      no_pembelian: formFilter.id,
      no_faktur: formFilter.no_faktur,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      lunas: alwaysLunas ? 1 : formFilter.lunas,
      kategory_tanggal: formFilter.kategory_tanggal,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status: isNull(status) ? "" : parseInt(status),
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
          is_PO: formFilter.is_PO,
        }
      : {};

    const api = await instance4.post(urlGet, {
      ...defaultFilter,
      ...isPO,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.totalData),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePembelianById = async (id) => {
  try {
    console.log(id);
    const api = await instance4.post(urlDelete, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus pembelian",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const getAllLaporanPembelianFarmasiExport = async (
  formFilter,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      no_pembelian: formFilter.id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      kategory_tanggal: formFilter.kategory_tanggal,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status,
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
          is_PO: formFilter.is_PO,
        }
      : {};

    const isLunas = alwaysLunas
      ? {
          lunas: true,
        }
      : formFilter.is_PO === "2"
      ? {
          lunas: true,
        }
      : formFilter.is_PO === "3"
      ? { lunas: false }
      : {};

    const validPost = {
      ...defaultFilter,
      ...isPO,
      ...isLunas,
    };

    const api = await instance4.post(
      urlAllDaftarPembelianFarmasiExport,
      validPost
    );
    const res = api.data;
    if (res.status) {
      return {
        state: true,
        message: "success",
      };
    }

    return {
      state: false,
      message: "success",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID PEMBELIAN",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "po_id",
    disablePadding: false,
    label: "ID PO",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "status_lunas",
    disablePadding: false,
    label: "STATUS LUNAS",
    align: "center",
    minWidth: "140px",
  },
  {
    id: "faktur_no",
    disablePadding: false,
    label: "NO FAKTUR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_suplier",
    disablePadding: false,
    label: "SUPPLIER",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "faktur_tgl",
    disablePadding: false,
    label: "TGL FAKTUR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "jatuhtempo_tgl",
    disablePadding: false,
    label: "TGL JATUH TEMPO",
    align: "left",
    sort: false,
    minWidth: "200px",
  },

  {
    id: "kedatangan_tgl",
    disablePadding: false,
    label: "TGL KEDATANGAN",
    align: "left",
    sort: false,
    minWidth: "200px",
  },

  {
    id: "tagih_tgl",
    disablePadding: false,
    label: "TGL TAGIH",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
   {
    id: "tanggal_bayar",
    disablePadding: false,
    label: "TGL BAYAR",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "sub_total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "nilai_tax",
    disablePadding: false,
    label: "TAX",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "nilai_discount",
    disablePadding: false,
    label: "DISC.",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "biayalain",
    disablePadding: false,
    label: "BIAYA LAIN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "ongkos",
    disablePadding: false,
    label: "BIAYA ONGKOS",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "bayar",
    disablePadding: false,
    label: "BAYAR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "sisa",
    disablePadding: false,
    label: "SISA",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusPembelianBadge = ({ status }) => {
  if (status === STATUS_OPEN_DRAFT_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Draft"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PROSES_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Tutup"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_SELESAI_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Terproses"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan </p>;
  }
};

export const RenderStatusLunasBadge = ({ status }) => {
  return (
    <MasterButton
      style={{ borderRadius: 20 }}
      name={"Lunas"}
      color={"green"}
      type="button"
      disabled
    />
  );
};

export const ListTotalPembelianFetch = async (
  formFilter,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      no_pembelian: formFilter.id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      kategory_tanggal: formFilter.kategory_tanggal,
      lunas: alwaysLunas ? 1 : formFilter.lunas,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status,
      no_po: formFilter.no_po,
      no_faktur: formFilter.no_faktur,
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
          is_PO: formFilter.is_PO,
        }
      : {};

    const isLunas = alwaysLunas
      ? {
          lunas: true,
        }
      : formFilter.is_PO === "2"
      ? {
          lunas: true,
        }
      : formFilter.is_PO === "3"
      ? { lunas: false }
      : {};

    const api = await instance4.post(LIST_URL_WAREHOUSE.pembelianPBF.total, {
      ...defaultFilter,
      ...isPO,
      ...isLunas,
    });
    const res = api.data;
    if (res.status === 200) {
      return res.data[0];
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const STATE_PEMBELIAN_TERPOSES = {
  dataBarang: [],
  id_pembelian: "",
  gudang: "",
  status: "",
  total_pembayaran: 0,
  jumlah_pembayaran: 0,
  valid_data: 0,
  unvalid_data: 0,
  no_faktur:"",
  supplier:"",
};

export const headCellsTerproses = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },

  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "master_barang",
    disablePadding: false,
    label: "MASTER BARANG",
    align: "center",
    minWidth: "200px",
    rowSpan: 1,
    colSpan: 4,
    child: [
      {
        id: "id_barang",
        disablePadding: false,
        label: "ID BARANG",
        align: "center",
        minWidth: "100px",
      },
      {
        id: "nama_barang",
        disablePadding: false,
        label: "NAMA BARANG",
        align: "center",
        minWidth: "180px",
      },
      {
        id: "rs_qty",
        disablePadding: false,
        label: "QTY",
        align: "center",
        sort: false,
        minWidth: "100px",
      },
      {
        id: "rs_persediaan",
        disablePadding: false,
        label: "PERSEDIAAN",
        align: "center",
        minWidth: "100px",
      },
    ],
  },
  {
    id: "pembelian",
    disablePadding: false,
    label: "PEMBELIAN",
    align: "center",
    minWidth: "200px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "pemb_qty",
        disablePadding: false,
        label: "QTY",
        align: "center",
        minWidth: "100px",
      },
      {
        id: "pemb_harga_per_qty",
        disablePadding: false,
        label: "HARGA BELI",
        align: "center",
        minWidth: "180px",
      },
      {
        id: "pemb_persediaan",
        disablePadding: false,
        label: "PERSEDIAAN",
        align: "center",
        sort: false,
        minWidth: "100px",
      },
    ],
  },
  {
    id: "inventory",
    disablePadding: false,
    label: "INVENTORY",
    align: "center",
    minWidth: "200px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "inv_qty",
        disablePadding: false,
        label: "QTY",
        align: "center",
        minWidth: "100px",
      },
      {
        id: "inv_hargapokok",
        disablePadding: false,
        label: "HARGA POKOK",
        align: "center",
        minWidth: "180px",
      },
      {
        id: "inv_persediaan",
        disablePadding: false,
        label: "PERSEDIAAN",
        align: "center",
        sort: false,
        minWidth: "100px",
      },
    ],
  },
  {
    id: "hasil_inv_baru",
    disablePadding: false,
    label: "HASIL INVENTORY BARU",
    align: "center",
    minWidth: "200px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "inv_qty_akhir",
        disablePadding: false,
        label: "QTY",
        align: "center",
        minWidth: "100px",
      },
      {
        id: "inv_harga_pokok_akhir",
        disablePadding: false,
        label: "HARGA POKOK",
        align: "center",
        minWidth: "180px",
      },
      {
        id: "inv_persediaan_akhir",
        disablePadding: false,
        label: "PERSEDIAAN",
        align: "center",
        sort: false,
        minWidth: "100px",
      },
    ],
  },
  {
    id: "hasil_master_barang",
    disablePadding: false,
    label: "HASIL MASTER BARANG",
    align: "center",
    minWidth: "200px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "master_qty_akhir",
        disablePadding: false,
        label: "QTY",
        align: "center",
        minWidth: "100px",
      },
      {
        id: "master_harga_pokok_akhir",
        disablePadding: false,
        label: "HARGA POKOK",
        align: "center",
        minWidth: "180px",
      },
      {
        id: "master_persediaan_akhir",
        disablePadding: false,
        label: "PERSEDIAAN",
        align: "center",
        sort: false,
        minWidth: "100px",
      },
    ],
  },
];

export const hapusPembelianTerkonfirmasi = async (datas) => {
  try {
    const api = await instance4.post(urlHapusPembelian, datas);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    if(!isEmpty(error?.response?.data?.err?.response?.message)){
        return {
            state: false,
            message: error?.response?.data?.err?.response?.message,
          };
    }else{
        return {
          state: false,
          message: error?.response?.data?.message,
        };
    }
  }
};

export const getDataPembelian = async (data) => {
  try {
    const api = await instance4.post(urlHapusPembelian, {
      id_pembelian: data,
      force: false,
    });
    const res = api.data;
    if (res.status === 203) {
      return {
        state: true,
        data : res.body[0],
        detail : res.body[1][0],
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
